import React from 'react'
import fallbackProjectsImage from './../images/projects/projectsFallbackimage.png';
import Chip from '@material-ui/core/Chip';
import {AiOutlineFire} from "react-icons/ai";
import PrimaryButton from './PrimaryButton';
import SecondaryButton from './SecondaryButton';
export default function OffersCard(props) {
    const {name,category,salePercent,images,price,priceAfterSale,description,slug} = props;
    return (
            <div className='offersCard'>
                <Chip
                    className='exclusive'
                    color="secondary"
                    size="small"
                    icon={< AiOutlineFire />}
                    label={`Exclusive ${salePercent}% discount`}></Chip>
                <div className="site-img">
                    <img src={images[0].file.url || fallbackProjectsImage} alt={images[0].title}/>
                </div>
                <div className="site-details">
                    <h3>{name}</h3>
                    <p>{description}</p>
                    <span className='category'>{category}</span>
                    <div className="price">
                        <span className='after-sale'>{priceAfterSale} LE</span>
                        <span className='before-sale'>{price} LE</span>
                    </div>
                    <div className="flexCenter offer-btns">
                        <PrimaryButton path={'projects'} slug={slug} title='Preview'/>
                        <SecondaryButton path={'projects'} slug={slug}/>
                    </div>
                </div>
                <div className="overlay-data"></div>
            </div>
        )
}

